// DEPENDENCIES
import React, { useEffect } from "react";
import tinycolor from "tinycolor2";

// CSS
import "./DropboxFolderCard.css";

// MUI COMPONENTS
import {
	Folder as FolderIcon,
	CheckBox as CheckBoxIcon,
} from "@mui/icons-material";

// MUI ICONS

// CUSTOM COMPONENTS

// CONSTANTS

// OTHER

// REACT COMPONENT
const DropboxFolderCard = ({ bgColor = "#184C93", ...props }) => {
	// STATES

	// USE EFFECT
	useEffect(() => {}, []);

	// INPUT HANDLERS

	// API FUNCTIONS

	// HELPER FUNCTIONS

	// RENDER
	return (
		<div
			style={{
				backgroundColor: props.highlighted
					? tinycolor(bgColor).darken(20).toString()
					: bgColor,
			}}
			className="DropboxFolderCard"
			onClick={() => props.folderClicked(props.folder.name)}
		>
			{props.highlighted ? (
				<CheckBoxIcon fontSize="small" color="white" />
			) : (
				<FolderIcon fontSize="small" color="white" />
			)}
			<h1>{props.folder.name}</h1>
		</div>
	);
};

// EXPORT
export default DropboxFolderCard;
